module.exports = __webpack_public_path__ + "img/safe-payemnt.05ae7cc4.jpg";